import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 segundos de timeout para evitar requisições travadas
});

// Interceptor para adicionar token JWT de autenticação
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwt_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token inválido ou expirado - remover token e redirecionar para login
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('user_data');
      
      // Redirecionar para login apenas se não estiver já na página de login
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

/**
 * Verifica se o erro é de rate limit do GitHub
 * @param error - Erro do axios
 * @returns true se for rate limit do GitHub, false caso contrário
 */
export const isGitHubRateLimitError = (error: any): boolean => {
  if (!error?.response?.data) return false;
  
  const errorMessage = error.response.data.error || error.response.data.message || '';
  const errorString = typeof errorMessage === 'string' ? errorMessage.toLowerCase() : '';
  
  return errorString.includes('rate limit') || 
         errorString.includes('ratelimit') ||
         errorString.includes('api rate limit exceeded');
};

/**
 * Retorna uma mensagem amigável para erro de rate limit do GitHub
 */
export const getGitHubRateLimitMessage = (): string => {
  return 'Limite de requisições do GitHub atingido. Por favor, tente novamente em alguns instantes.';
};

export default api;
